import axios from "axios";
import { getBaseURLforBackEnd  , getConfigAxios } from '@/utils.js'
import master_data from "./master_data";
 


// [ { "id": "63040378", "idopd": "62017839", "dockind": "CBC", "text": "LN : 63040378 / ปุย(62017839) / ธีรพัฒน์ พัฒนศิษฏางกูร / Male ", "icon": "fa fa-paw", "dropDisabled": true, "kind": 2, "selected": false },
//   { "id": "63000010", "idopd": "62028058", "dockind": "CBC", "text": "LN : 63000010 / หมูหยอง(62028058) / ธันชนก ตีรณโชติ / Female ", "icon": "fa fa-paw", "dropDisabled": true, "kind": 2, "selected": false },
//   { "id": "PnacyDSVZN", "text": "New Folder", "opened": true, "children":
//                                       [ { "id": "g8dvUy8HfO", "text": "New Folder", "opened": true, "children": [], "selected": false, "kind": 1 } ], "selected": true, "kind": 1 } ]



export default {
    namespaced: true,
    state: {

        listofcytoresultrecently :[],
        first : 10,  // init
        skip :  0,     // init
        step :  10, // step should equl first


        statofcbclast7day :[],
        fetchStatOfCBCLast7dayCompleted : false,


        newsArr : [],



        imagesArrRecently : [],
        firstImagesArrRecently : 10,  // init
        skipImagesArrRecently :  0,     // init


        activeTabViewImages : 0,
        isMoreBtnLoading : false,
    },

    getters: {

        // listofcytoresultrecentlyCytology(state){
        //     return state.listofcytoresultrecently.
        // }

    },

    mutations: {

        //
        setActiveTabViewImages(state,activeTabViewImages){
            state.activeTabViewImages = activeTabViewImages
        },
        setIsMoreBtnLoading(state,isMoreBtnLoading){
            state.isMoreBtnLoading = isMoreBtnLoading
        },


        // ImagesArrRecently
        setImagesArrRecently(state,data){
            state.imagesArrRecently = state.imagesArrRecently.concat(data)
        },
        setClearImagesArrRecently(state){
            state.imagesArrRecently = []
        },
        setFirstImagesArrRecently(state,firstImagesArrRecently){
            state.firstImagesArrRecently = firstImagesArrRecently
        },
        setSkipImagesArrRecently(state,skipImagesArrRecently){
            state.skipImagesArrRecently = skipImagesArrRecently
        },




        setNewsArr(state,newsArr){
            state.newsArr = newsArr
        },


        setStatofcbclast7day(state,statofcbclast7day){
            state.statofcbclast7day = statofcbclast7day
        },
        setFetchStatOfCBCLast7dayCompleted(state,fetchStatOfCBCLast7dayCompleted){
            state.fetchStatOfCBCLast7dayCompleted = fetchStatOfCBCLast7dayCompleted
        },

        setSkip(state,skip){
            state.skip = skip
        },


        /* eslint-disable no-console */
        setAddArr(state,data){
            state.listofcytoresultrecently =  state.listofcytoresultrecently.concat(data)
        },

        setClearListOfCytoResultRecently(state){
            state.listofcytoresultrecently = []
        }
    },

    actions: {

        
        // Dev experiment: HTTP-complete actions; legacy actions below are unchanged.
        fetchListOfCytoresultRecentlySequential({
          state,
          commit
        }) {
          const datTo = {
            "first": state.first,
            "skip": state.skip
          };
          axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`;
          return axios.post(`${getBaseURLforBackEnd()}/api/listofcytoresultrecently`, datTo, getConfigAxios()).then(res => {
            commit('setAddArr', res.data);
            return res;
          });
        },

        fetchImagesRecentlySequential({
          state,
          commit
        }) {
          const datTo = {
            "first": state.firstImagesArrRecently,
            "skip": state.skipImagesArrRecently
          };
          axios.defaults.headers.common['Authorization'] = `Bearer ${master_data.state.access_token}`;
          return axios.post(`${getBaseURLforBackEnd()}/api/listof_image_result_recently`, datTo, getConfigAxios()).then(res => {
            commit('setImagesArrRecently', res.data);
            return res;
          });
        },

        fetchStatOfCBCLast7daySequential({
          commit
        }) {
          return axios.post(`${getBaseURLforBackEnd()}/api/statofcbclast7day`, getConfigAxios()).then(res => {
            commit('setStatofcbclast7day', res.data);
            commit('setFetchStatOfCBCLast7dayCompleted', true);
          });
        },

        fetchNewsArrSequential({
          commit
        }) {
          return axios.post(`${getBaseURLforBackEnd()}/api/listoflabnews_v2`, getConfigAxios()).then(res => {
            commit('setNewsArr', res.data);
          });
        },
clearListOfCytoResultRecently({commit}){
            commit('setClearListOfCytoResultRecently')
        },

        produceListOfCytoresultRecently({commit},listofcytoresultrecently){
            commit('setListOfCytoresultRecently', listofcytoresultrecently)
        },
        produceSkip({commit},skip){
            commit('setSkip', skip)
        },
        /* eslint-disable no-console */
        fetchListOfCytoresultRecently({state,commit}) {
            const datTo ={
                "first": state.first,
                "skip": state.skip
            }
            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
                axios.post(`${getBaseURLforBackEnd()}/api/listofcytoresultrecently`,datTo,getConfigAxios())
                    .then((res)=>{
                        commit('setAddArr',res.data)
                        resolve(res)
                    })
                    .catch(err =>{
                        console.log("err")
                        console.log(err)
                    })

            })
        } ,


        fetchImagesRecently({state,commit}) {
            const datTo ={
                "first": state.firstImagesArrRecently,
                "skip": state.skipImagesArrRecently
            }
            console.log("fetchImagesRecently")
            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${master_data.state.access_token }`
                axios.post(`${getBaseURLforBackEnd()}/api/listof_image_result_recently`,datTo,getConfigAxios())
                    .then((res)=>{
                        commit('setImagesArrRecently',res.data)
                        resolve(res)
                    })
                    .catch(err =>{
                        console.log("err")
                        console.log(err)
                    })

            })
        } ,






        fetchStatOfCBCLast7day({commit}){
            axios.post(`${getBaseURLforBackEnd()}/api/statofcbclast7day` , getConfigAxios())
                .then((res)=>{
                    commit('setStatofcbclast7day',res.data)
                    commit('setFetchStatOfCBCLast7dayCompleted',true)
                })
        } ,


        fetchNewsArr({commit}){
            // axios.post(`${getBaseURLforBackEnd()}/api/listoflabnews` , getConfigAxios())
            axios.post(`${getBaseURLforBackEnd()}/api/listoflabnews_v2` , getConfigAxios())
                .then((res)=>{
                    commit('setNewsArr',res.data)
                })
        },


         


    }
}